const AppConfig = {
  // মূল Flask API সার্ভার
  API_BASE_URL: 'https://epo-closet-main-server.sparkx-ai.shop/',
  CompanyName: 'Epo Kart',
  phoneNumber: '01403942587',
  contactEmail: 'contact@epocloset.com',
  // WhatsApp লিঙ্ক
  WhatsAppLink: 'https://wa.me/01403942587',
  WhatsAppNumber: '+8801403942587',
  // Facebook Messenger লিঙ্ক
  MessengerLink: 'https://m.me/epocloset',
  // WhatsApp ডিফল্ট মেসেজ
  WhatsAppDefaultMessage: 'Hello! I visited your website and would like some information.',
  DeliveryManURL: 'https://epo-closet-main-server.sparkx-ai.shop/delivery-man',
  WELCOME_COUPON_CODE: 'WELCOME10', // নতুন ব্যবহারকারীদের জন্য
};

export default AppConfig;